module.exports = __webpack_public_path__ + "3c84310b4e6f1856772e18531df4e808.svg";